// Library Imports
import React from 'react'

// Component Imports
import PricingPlans from './PricingPlans'
import PageBanner from '../../components/banner/PageBanner'

function Pricing() {
    return (
      <div className='pricing-page-container'>
        <PageBanner pageName="Pricing" />
        <PricingPlans />
      </div>
    )
  }
  
  export default Pricing